import PropTypes from 'prop-types'
import React from 'react'
import { Icon, Link } from 'Blocks'
import config from 'Config'
import { UrlBuilder } from 'Utils'
import { NAV_PANEL_CONTENTS } from 'Constants'

const PanelTrigger = props => {
  const handleOpen = () => {
    props.toggleNavPanel(NAV_PANEL_CONTENTS.FILTERS)
  }

  const setView = () => {
    const builder = new UrlBuilder(props.queryString)
    return builder.setDialogView('Refine').getQueryString()
  }

  return props.screenType === 'small' ? (
    <Link to={setView()} className="panel-trigger">
      <Icon className="panel-trigger__icon" name="filters" />
      <span className="panel-trigger__text">
        {config.filters.navPanel.triggerText}
      </span>
    </Link>
  ) : (
    <div onClick={handleOpen} className="panel-trigger">
      <Icon className="panel-trigger__icon" name="filters" />
      <span className="panel-trigger__text">
        {config.filters.navPanel.triggerText}
      </span>
    </div>
  )
}

PanelTrigger.propTypes = {
  queryString: PropTypes.any,
  screenType: PropTypes.string,
  toggleNavPanel: PropTypes.func
}

export default PanelTrigger
